import { userVids } from "@extensions/enums";
import { useEffect, useState } from "react";
import { Form, Input, Select, Space, Button, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { serverFetch } from "@server";

const CompanyUser = ({itemDefault, onClose}) => {

  const [item, setItem] = useState({...itemDefault});
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => form.setFieldsValue(item), [])


  const onValuesChange = value => setItem({...item, ...value});

  const onSave = () => {
    setLoading(true);
    serverFetch("user", { method: "POST", bodyData: item })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onCancel = () => onClose(false);

  return<div>
    <div className="misoft-modal-overlay" onClick={e => e.target === e.currentTarget && onClose(false)}>
      <div className="misoft-modal-content" style={{width: 800}}>
        <div className="misoft-modal-title">
          <span>Пользователь</span>
          <CloseOutlined
            className="misoft-section-title-close" 
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading} style={{maxWidth: 800}}>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          <Form.Item label="Вид" name="vid"><Select options={userVids} /></Form.Item>

          <Form.Item label=" "><Space>
            <Button className="misoft-btn" onClick={onSave}>Сохранить</Button>
            <Button className="misoft-btn" onClick={onCancel}>Отмена</Button>
          </Space></Form.Item>
        </Form>
      </div>
    </div>
  </div>
}

export default CompanyUser;